const META_ID = "nofollow-meta";

const appendNofollowMeta = () => {
  const prevMetaElement = document.getElementById(META_ID);

  if (prevMetaElement) { return } 


  const metaElement = document.createElement("meta");

  metaElement.id = META_ID;
  metaElement.name = "robots"
  metaElement.content = "noindex, nofollow"
  document.head.appendChild(metaElement);
};

const removeNofollowMeta = () => {
  const prevMetaElement = document.getElementById(META_ID);

  if (prevMetaElement) {
    prevMetaElement.remove();   
  }
}

export {
  appendNofollowMeta,
  removeNofollowMeta
};

